import React from 'react';
import { ordinalize } from 'inflection';

import Link from '@buyside/components/presentation/Link/link';
import PaladinReviewModal from '@buyside/components/presentation/IdeaShowPage/IdeaStatusBar/PaladinReviewModal/paladinReviewModal';

import { isEmpty } from '@buyside/util/lodashAlt';
import { ideaEditUrl, qualityGuidelinesUrl } from '@buyside/util/urlHelper';

import { IdeaCoreQuery } from '@interfaces/graphql-typings';

import styles from '../ideaStatusBarStyles.scss';

const IdeaStatusFlaggedForReview: React.FC<{
  ideaId: string;
  paladinReviews?: IdeaCoreQuery['idea']['paladinReviews'];
}> = ({ ideaId, paladinReviews }) => {
  return (
    <div className={styles.ideaStatusFlaggedForReview}>
      <div>
        Your idea was <strong>flagged for further revision</strong> by a trusted member of the
        community. Please see feedback below and contact{' '}
        <Link to="mailto:support@sumzero.com">support@sumzero.com</Link> with any questions. Refer
        to the <Link to={qualityGuidelinesUrl()}>SumZero Quality Guidelines</Link> for more
        information. You may <Link to={ideaEditUrl(ideaId)}>edit your idea</Link> and resubmit for
        approval.
      </div>
      <div className={styles.paladinReviews}>
        {!isEmpty(paladinReviews) &&
          paladinReviews?.map((review, idx) => (
            <PaladinReviewModal
              key={`paladin-review-${idx}`}
              description={review.description || ''}
              buttonText={`${paladinReviews.length > 1 &&
                ordinalize(String(idx + 1))} Review Feedback`}
            />
          ))}
      </div>
    </div>
  );
};

export default IdeaStatusFlaggedForReview;
